<header class="testosterone-hq-header" [class._sticked]="isSticked" [class._showed]="isShowed">
  <div
    class="container is-flex is-flex-direction-row is-flex-wrap-nowrap is-justify-content-space-between is-align-items-center"
  >
    <img
      *ngIf="restrictedNavigation"
      class="header-img"
      ngSrc="assets/img/testosterone-hq-logo-black.svg"
      alt="Testosterone HQ Logo"
      data-qa-id="non-clickable-logo"
      width="300"
      height="43"
    />
    <a *ngIf="!restrictedNavigation" class="is-flex" href="https://www.testosteronehq.com/" data-qa-id="clickable-logo">
      <img
        class="header-img"
        ngSrc="assets/img/testosterone-hq-logo-black.svg"
        width="300"
        height="43"
        alt="Testosterone HQ Logo"
        priority
      />
    </a>
  </div>
</header>
<div class="main-content">
  <ng-content></ng-content>
</div>
<footer class="testosterone-hq-footer">
  <div class="container">
    <div class="testosterone-hq-footer-inner">
      <img
        class="footer-img"
        ngSrc="assets/img/testosterone-hq-logo-white.svg"
        alt="Testosterone HQ Logo"
        data-qa-id="testosterone-hq-footer-img"
        height="50"
        width="270"
        priority
      />
      <p class="testosterone-hq-footer-copy">Copyright &copy; {{ today | date: 'y' }}. All rights reserved.</p>
    </div>
  </div>
  <div class="testosterone-hq-footer-bg">
    <img src="assets/img/testosterone-hq-footer-bg.jpg" alt="" />
  </div>
</footer>
